import { Chip } from '@material-ui/core';
import React from 'react';

import { CHIPS_CONTAINER_STYLE, CHIP_LOCATION_STYLE, CHIP_TYPE_STYLE } from './utils';

export interface AlertChipsProps {
  location: string;
  type: string | null;
}

export const AlertChips: React.FC<AlertChipsProps> = ({ location, type }) => (
  <div style={CHIPS_CONTAINER_STYLE}>
    <Chip label={location} size="small" style={CHIP_LOCATION_STYLE} />
    {type && <Chip label={type} size="small" style={CHIP_TYPE_STYLE} />}
  </div>
);
